module.exports = __webpack_public_path__ + "static/media/indianraisinsfront.46503ad6.jpg";